import { Link } from 'react-router-dom';
import { ArrowLeft, Calculator, Lock } from 'lucide-react';
import { ComingSoonInterest } from '@/components/ComingSoonInterest';

/**
 * Coming Soon placeholder for the Rigging Calculator.
 * The real calculator (RiggingCalculatorPage.tsx) is kept in the codebase
 * but intentionally NOT routed here until it has been vetted & accepted
 * by the major tower owners. Feature flags back on in App.tsx when ready:
 *   <Route path="/rigging-calculator" element={<RiggingCalculatorPage />} />
 */
export function RiggingCalculatorComingSoonPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 sticky top-0 z-10">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <Link to="/dashboard" className="text-gray-600 hover:text-gray-900">
                <ArrowLeft className="h-6 w-6" />
              </Link>
              <div className="flex items-center gap-2">
                <Calculator className="h-7 w-7 text-orange-600" />
                <h1 className="text-2xl font-bold text-gray-900">Rigging Calculator</h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Coming Soon body */}
      <div className="max-w-2xl mx-auto px-6 py-16">
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-10 text-center">
          <div className="mx-auto w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center mb-6">
            <Lock className="h-8 w-8 text-gray-400" />
          </div>
          <div className="inline-flex items-center gap-2 bg-amber-100 text-amber-700 text-xs font-bold px-3 py-1 rounded-full mb-4">
            Coming Soon
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-3">Advanced Rigging Calculator</h2>
          <p className="text-gray-600 mb-3">
            Professional tower rigging with visual diagrams and force calculations is being
            validated and will be available here soon.
          </p>
          <p className="text-sm text-gray-500">
            Until then, upload your rigging calculations as a PDF attachment on your
            Construction Plan.
          </p>
          {/* WD-T4 §10: demand gauge — real registrations, idempotent per user. */}
          <div className="mt-8 flex flex-col items-center gap-4">
            <ComingSoonInterest module="RIGGING_CALCULATOR" />
            <Link
              to="/construction-plans"
              className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition"
            >
              Go to Construction Plans
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}